import { ICompany } from '@shared/interfaces/company.interface';
import { INotification } from '@shared/interfaces/notification.interface';
import { ILibrary } from '@shared/interfaces/library.interface';
import { IUser } from '@shared/interfaces/user.interface';

export class Notification implements INotification {
  public id: string;
  public type?: string;
  public subject: string;
  public title?: string;
  public body: string;
  public cta?: string;
  public url?: string;
  public sendDate?: number;
  public company?: Partial<ICompany>;
  public attachments?: ILibrary[];
  public to?: Partial<IUser>[];
  public replyTo?: any[];

  constructor(partial: Partial<INotification>) {
    Object.assign(this, partial);
  }

  public get openSendNotificationModal() {
    return {
      icon: '',
      label: 'Send Notification',
      class: 'btn-sm'
    };
  }
  public get openSendNotificationModalFr() {
    return {
      icon: '',
      label: "Envoyer un courriel",
      class: 'btn-sm'
    };
  }
}
